/**
 * C3 env-flagged API client — Hono when VITE_USE_HONO_API=true and VITE_API_BASE_URL set.
 */
import {
  resolveApiBaseUrlFromEnv,
  isHonoApiModeFromEnv,
} from './apiClient.logic'

function envBag() {
  return {
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string | undefined,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL as string | undefined,
    VITE_USE_HONO_API: import.meta.env.VITE_USE_HONO_API as string | undefined,
  }
}

export function resolveApiBaseUrl(): string {
  return resolveApiBaseUrlFromEnv(envBag())
}

export function isHonoApiMode(): boolean {
  return isHonoApiModeFromEnv(envBag())
}

export type ApiFetchInit = RequestInit & { accessToken?: string | null }

export async function apiFetch(path: string, init: ApiFetchInit = {}): Promise<Response> {
  const base = resolveApiBaseUrl()
  const url = path.startsWith('http')
    ? path
    : `${base}${path.startsWith('/') ? path : `/${path}`}`

  const headers = new Headers(init.headers)
  if (init.accessToken) {
    headers.set('authorization', `Bearer ${init.accessToken}`)
  }
  if (!headers.has('content-type') && init.body && !(init.body instanceof FormData)) {
    headers.set('content-type', 'application/json')
  }

  const rest: RequestInit = {
    method: init.method,
    body: init.body,
    signal: init.signal,
    credentials: init.credentials,
    cache: init.cache,
    redirect: init.redirect,
    referrer: init.referrer,
    mode: init.mode,
    headers,
  }
  return fetch(url, rest)
}
